var _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 48,
    viewBox: "0 0 64 48",
    fill: "none",
    stroke: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.0452 44.4445H19.9554C19.2463 44.4445 18.667 43.9007 18.667 43.236V4.76535C18.667 4.09952 19.2463 3.55566 19.9554 3.55566H44.0452C44.7544 3.55566 45.3337 4.09952 45.3337 4.76535V43.236C45.3337 43.9007 44.7544 44.4445 44.0452 44.4445Z",
    strokeWidth: 1.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5042 36.4446H26.4969C26.1016 36.4446 25.7783 36.1282 25.7783 35.7413V12.2589C25.7783 11.8721 26.1016 11.5557 26.4969 11.5557H37.5042C37.8995 11.5557 38.2228 11.8721 38.2228 12.2589V35.7413C38.2228 36.1282 37.8995 36.4446 37.5042 36.4446Z",
    strokeWidth: 0.90948
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30.4443,
    y: 16,
    width: 3.11111,
    height: 16,
    className: "brilliant-card-img-left-fill",
    fill: "black",
    rx: 1.55556
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/Switch.e997e03a3367befee6b10e1c98d171d9.svg";
export { ForwardRef as ReactComponent };